
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

export const EmptyState = () => {
  return (
    <Card className="w-full h-48 bg-white border border-[#CCCCCC]">
      <CardHeader className="bg-[#E8F0F8] rounded-t-lg">
        <CardTitle className="text-lg text-[#333B44]">Emotion Tracking</CardTitle>
      </CardHeader>
      <CardContent className="flex h-32 items-center justify-center">
        <p className="text-[#5A636E]">No emotion data available</p>
      </CardContent>
    </Card>
  );
};
